export interface PhoneCountry {
  countryCode?: string;
}

// Normalises PH mobile numbers to the same shape the legacy wizard stored,
// so we don't regress the value format the backend already accepts.
export function normalizeMobileNumber(
  value: string,
  country?: PhoneCountry
): string {
  const compact = value.replace(/[^\d+]/g, "");
  if (country?.countryCode !== "ph") {
    return compact && !compact.startsWith("+") ? `+${compact}` : compact;
  }
  if (/^\+630/.test(compact)) return compact.replace(/^\+630/, "+63");
  if (/^\+63/.test(compact)) return compact;
  if (/^09/.test(compact)) return compact.replace(/^0/, "+63");
  if (/^630/.test(compact)) return compact.replace(/^630/, "+63");
  if (/^63/.test(compact)) return `+${compact}`;
  return compact;
}

export function isValidMobileNumber(value: string | undefined): boolean {
  const normalized = normalizeMobileNumber(value || "", { countryCode: "ph" });
  if (normalized.startsWith("+63")) return /^\+639\d{9}$/.test(normalized);
  return /^\+[1-9]\d{6,14}$/.test(normalized);
}
